/** Cell-relative visual scale helpers. Presentation only. */

export const CELL_SIZE_MIN = 9
export const CELL_SIZE_MAX = 62

export function clampCellSize(cellSize: number): number {
  if (!Number.isFinite(cellSize) || cellSize <= 0) return CELL_SIZE_MIN
  return Math.min(CELL_SIZE_MAX, Math.max(CELL_SIZE_MIN, cellSize))
}

/** Convert logical cell units to pixels. */
export function cellToPx(cells: number, cellSize: number): number {
  return cells * clampCellSize(cellSize)
}

/**
 * Normalized visual scale factor across the M5 cell-size range.
 * ~0.55 at tiny mobile cells, ~1.0 around 24px, ~1.35 at large desktop cells.
 */
export function visualScaleForCell(cellSize: number): number {
  const c = clampCellSize(cellSize)
  return 0.45 + (c / 40) * 0.9
}

export function strokeWidthForCell(cellSize: number, weight: 'hair' | 'thin' | 'medium' | 'bold' = 'thin'): number {
  const c = clampCellSize(cellSize)
  const base =
    weight === 'hair' ? 0.04 : weight === 'thin' ? 0.08 : weight === 'medium' ? 0.12 : 0.18
  return Math.max(1, Math.round(c * base))
}

export function fontSizeForCell(cellSize: number, ratio = 0.55, min = 8, max = 28): number {
  const c = clampCellSize(cellSize)
  return Math.max(min, Math.min(max, Math.floor(c * ratio)))
}

/** Snap presentation coordinates to avoid half-pixel blur on grid-aligned art. */
export function alignPx(value: number): number {
  return Math.round(value)
}
